import { V11_CONFIG } from '../../../mastery';

/** @see V11_CONFIG.STRUGGLING_THRESHOLD — single source of truth (D-SCAN-2 D2-4) */
export const STRUGGLING_THRESHOLD = V11_CONFIG.STRUGGLING_THRESHOLD;

/**
 * Determines if a student needs attention based on their mastery score.
 * A student needs attention if they have practiced (practicedCount > 0)
 * and their mastery is below the struggling threshold.
 */
export function needsAttention(mastery: number, practicedCount: number = 1): boolean {
  return practicedCount > 0 && mastery < STRUGGLING_THRESHOLD;
}